export const cpnjRegexFormat = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;

// Scanner Expressions Formats
export const scannerCodeWithOptionalQuantityPrefixFormat = /^(?:(-?\d{0,11}(?:,\d{0,4})?)\*)?([^*]{0,60})$/;
export const scannerCodeWithOptionalQuantityPrefixValidadeFormat = /^(?:(-?\d{1,11}(?:,\d{1,4})?)\*)?([^*]{1,60})$/;
